import { z } from "zod";
/**
 * Project Pulse — no per-instance params. The projects it shows are a domain
 * read resolved by the host from the mock layer (one per health), not stored
 * on the placement. This is a deliberate improvement over the oracle, which
 * passed a denormalized project array through `params.projects`.
 */
export const ProjectPulseParamsSchema = z.object({}).strict();
export const defaultProjectPulseParams = {};
//# sourceMappingURL=projectPulse.js.map